'use strict';

module.exports = {
    /**
     * 唤起分享dialog<br />
     * 对应native接口：doShare
     * @method hysdk.showShareItems
     * @category Share
     * @example ./showShareItems.js[1-8]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    showShareItems: {
        hy: {
            key: 'doShare'
        }
    },
    /**
     * 主动调起“分享到朋友圈”分享内容接口<br />
     * 对应native接口：shareTimeline
     * @method hysdk.shareTimeline
     * @category Share
     * @example ./shareTimeline.js[1-14]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | title | String | 标题 | X | 常用参数 |
     * | link | String | 链接 | X | 常用参数 |
     * | desc | String | 描述 | X | 常用参数 |
     * | imgUrl | String | 分享图标 URL | X | 常用参数 |
     * | success | Function | success 回调 | X | 常用参数 |
     * | fail | Function | fail 回调 | X | 常用参数 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    shareTimeline: {
        hy: {
            key: 'shareTimeline'
        }
    },
    /**
     * 主动调起“分享给朋友”分享内容接口<br />
     * 对应native接口：sendAppMessage
     * @method hysdk.shareAppMessage
     * @category Share
     * @example ./shareAppMessage.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    shareAppMessage: {
        hy: {
            key: 'sendAppMessage'
        }
    },
    /**
     * 主动调起“新浪微博”分享内容接口<br />
     * 对应native接口：shareWeiboApp
     * @method hysdk.shareWeiboApp
     * @category Share
     * @example ./shareWeiboApp.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    shareWeiboApp: {
        hy: {
            key: 'shareWeiboApp'
        }
    },
    /**
     * 主动调起“短信”分享内容接口<br />
     * 对应native接口：shareSMS
     * @method hysdk.shareSMS
     * @category Share
     * @example ./shareSMS.js[1-14]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    shareSMS: {
        hy: {
            key: 'shareSMS'
        }
    },
    /**
     * 主动调起“邮件”分享内容接口<br />
     * 对应native接口：shareEmail
     * @method hysdk.shareEmail
     * @category Share
     * @example ./shareEmail.js[1-15]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    shareEmail: {
        hy: {
            key: 'shareEmail'
        }
    },
    /**
     * 主动调起“去哪儿好友”分享内容接口<br />
     * 对应native接口：shareQunarIM
     * @method hysdk.shareQunarIM
     * @category Share
     * @example ./shareQunarIM.js[1-15]
     * @description
     *
     * 参数与 shareTimeline API一致
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    shareQunarIM: {
        hy: {
            key: 'shareQunarIM'
        }
    },
    /**
     * 注册监听后，就会监听页面的截屏事件。一旦用户进行了截屏操作，就会在屏幕右侧有个中间页提示分享<br />
     * 对应native接口：registerScreenshotShare
     * @method hysdk.registerScreenshotShare
     * @category Share
     * @example ./registerScreenshotShare.js[1-11]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    registerScreenshotShare: {
        hy: {
            key: 'registerScreenshotShare'
        }
    },
    /**
     * 当页面退出，或者不需要截屏监听的时候，就需要移除这个监听了。 需要注意的是：只要注册了一个监听，就需要在使用监听完成后移除一个监听。<br />
     * 不需要传入参数，没有回调<br />
     * 对应native接口：unregisterScreenshotShare
     * @method hysdk.unregisterScreenshotShare
     * @category Share
     * @example ./unregisterScreenshotShare.js[1-3]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    unregisterScreenshotShare: {
        hy: {
            key: 'unregisterScreenshotShare'
        }
    },
    /**
     * 用户主动截屏分享，当按下分享按钮，就会执行这个功能，弹出右侧的中间页提示分享。 用户主动截屏的话，不用注册监听。<br />
     * 对应native接口：screenshotAndShare
     * @method hysdk.screenshotAndShare
     * @category Share
     * @example ./screenshotAndShare.js[1-11]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    screenshotAndShare: {
        hy: {
            key: 'screenshotAndShare'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/share.js
// module id = 13
// module chunks = 0 2 4